<template>
  <div class="relative w-full h-full video-wrapper-play">
    <video
      id="video"
      ref="videoContainer"
      :src="url"
      class="w-full h-full rounded-[24px]"
      :loop="loop"
      :muted="muted"
      :poster="poster"
      :autoplay="autoplay"
      :controls="controls"
      webkit-playsinline="true"
      controlslist="nodownload"
      x5-playsinline="h5-page"
      x-webkit-airplay="allow"
      playsinline="true"
      @play="onPlay"
      @pause="onPause"
    ></video>

    <div
      v-show="showPlayBtn && !noIcon"
      class="absolute-full video-wrapper-play-btn"
      @click="onPlay"
    ></div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps<{
  url: string
  cover?: string
  loop?: boolean
  controls?: boolean
  autoplay?: boolean
  muted?: boolean
  poster?: string
  noIcon?: boolean
}>()
const videoContainer = ref<HTMLVideoElement>()
const showPlayBtn = ref(!props.autoplay)

const onPlay = () => {
  videoContainer.value?.play?.()
  showPlayBtn.value = false
}

const onPause = () => {
  videoContainer.value?.pause?.()
  showPlayBtn.value = true
}

onMounted(() => {
  if (props.autoplay && videoContainer.value) {
    const videoPlay = videoContainer.value.play()
    videoPlay.catch(() => {
      if (videoContainer.value) {
        videoContainer.value.playsInline = true
        videoContainer.value.autoplay = true
        // 视频元素可以选择静音后再播放,提示用户打开声音
        videoContainer.value.muted = true
        videoContainer.value.play()
      }
    })
  }
})

const videoBtnBg = computed(
  () => `url(${getFeUrl('/youyan-platform/png/icon-play.png')})`
)

const videoBtnHoverBg = computed(
  () => `url(${getFeUrl('/youyan-platform/png/icon-play-active.png')})`
)
</script>

<style lang="scss" scoped>
.video-wrapper-play {
  border-radius: 12px;
  :deep(video) {
    border-radius: 12px;
  }

  :deep(.vjs-big-play-button) {
    display: none;
  }
  :deep(.vjs-control-bar) {
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  &-btn {
    background-image: v-bind('videoBtnBg');
    background-repeat: no-repeat;
    background-size: 162px;
    background-position: center;
    cursor: pointer;
    &:hover {
      background-image: v-bind('videoBtnHoverBg');
    }
  }
}
</style>
